import { invalidatePreferenceConsumers, PREFERENCES_CHANGED_EVENT, PREFERENCES_REVISION_KEY } from './preferencesEvents';
import { httpService } from '../../shared/service/httpService';

export interface UserPreferences {
    id: string;
    user_id: string;
    created_at: string;
    updated_at: string;
    tema: number; // 0 for Light, 1 for Dark
    machine_order: string[];
    setor_order: string[];
    sidebar_order?: string[] | null;
}

export interface UserPreferencesUpdate {
    tema?: number;
    machine_order?: string[];
    setor_order?: string[];
    sidebar_order?: string[] | null;
}

class PreferencesService {
    private baseUrl = '/api/v1/preferencias';

    async getPreferences(): Promise<UserPreferences> {
        const response = await httpService.get<UserPreferences>(this.baseUrl);
        return response.data;
    }

    async updatePreferences(data: UserPreferencesUpdate, sourceId?: string): Promise<UserPreferences> {
        const response = await httpService.put<UserPreferences>(this.baseUrl, data);
        invalidatePreferenceConsumers();
        window.dispatchEvent(new CustomEvent(PREFERENCES_CHANGED_EVENT, { detail: { sourceId } }));
        try { localStorage.setItem(PREFERENCES_REVISION_KEY, `${Date.now()}:${Math.random()}`); } catch { /* Storage disabled; same-tab notification still works. */ }
        return response.data;
    }
}

export const preferencesService = new PreferencesService();
